import { createContext, useContext } from 'react';
import { useAuth } from './AuthContext';
import { usePromoPopup } from '../hooks/usePromoPopup';

const PromoPopupContext = createContext(null);

export const usePromoPopupContext = () => useContext(PromoPopupContext) || {};

// Lifted above <Routes> so LessonPlayer (a route) can call triggerOnLessonComplete()
// and the popup renderer (a sibling of <Routes>) can read the same showPopup state.
export const PromoPopupProvider = ({ children }) => {
  const { user } = useAuth();
  const popup = usePromoPopup(user);

  return (
    <PromoPopupContext.Provider value={popup}>
      {children}
    </PromoPopupContext.Provider>
  );
};
